export default __webpack_public_path__ + "img/1_10-b3e28c4e.png";